import { pageRoutes } from "./pageRoutes";

export const BreadcrumbItems = {
    DASHBOARD_ADMIN: {
        text: "Dashboard",
        navigate: pageRoutes.DASHBOARD_ADMIN,
    },
    DONORS: {
        text: "Donors",
        navigate: pageRoutes.DONORS,
    },
    DONOR_DETAILS: {
        text: "Details",
        navigate: pageRoutes.DONOR_DETAILS,
    },
    OFFLINE_PAYMENTS: {
        text: "Offline Payments",
        navigate: pageRoutes.OFFLINE_PAYMENTS,
    },
    DONATION_HISTORY_ADMIN: {
        text: "Donation History",
        navigate: pageRoutes.DONATION_HISTORY_ADMIN,
    },
    CAMPAIGNS: {
        text: "Campaigns",
        navigate: pageRoutes.CAMPAIGNS,
    },
    CAMPAIGN_CREATE: {
        text: "Create",
        navigate: pageRoutes.CAMPAIGN_CREATE,
    },
    CAMPAIGN_EDIT: {
        text: "Edit",
        navigate: pageRoutes.CAMPAIGN_EDIT,
    },
    REFUND_REQUEST: {
        text: "Refund Requests",
        navigate: pageRoutes.REFUND_REQUEST,
    },
    PATIENTS: {
        text: "Patients",
        navigate: pageRoutes.PATIENTS,
    },
    PATIENTS_CREATE: {
        text: "Create",
        navigate: pageRoutes.PATIENTS_CREATE,
    },
    PATIENTS_EDIT: {
        text: "Edit",
        navigate: pageRoutes.PATIENTS_EDIT,
    },
    DESERVING_ITEMS: {
        text: "Deserving Items",
        navigate: pageRoutes.DESERVING_ITEMS,
    },
    DESERVING_ITEMS_CREATE: {
        text: "Create",
        navigate: pageRoutes.DESERVING_ITEMS_CREATE,
    },
    DESERVING_ITEMS_EDIT: {
        text: "Edit",
        navigate: pageRoutes.DESERVING_ITEMS_EDIT,
    },
    ADMIN_REPORTS: {
        text: "Reports",
        navigate: pageRoutes.ADMIN_REPORTS,
    },
    REPORT_CREATE: {
        text: "Create",
        navigate: pageRoutes.REPORT_CREATE,
    },
    REPORT_EDIT: {
        text: "Edit",
        navigate: pageRoutes.REPORT_EDIT,
    },
    USERS: {
        text: "Users",
        navigate: pageRoutes.USERS,
    },
    USER_CREATE: {
        text: "Create",
        navigate: pageRoutes.USER_CREATE,
    },
    USER_EDIT: {
        text: "Edit",
        navigate: pageRoutes.USER_EDIT_PROFILE,
    },
    USER_DETAILS: {
        text: "Details",
        navigate: pageRoutes.USER_DETAILS,
    },
    DASHBOARD_USER: {
        text: "Dashboard",
        navigate: pageRoutes.DASHBOARD_USER,
    },
    DONATION_HISTORY_USER: {
        text: "Donation History",
        navigate: pageRoutes.DONATION_HISTORY_USER,
    },
    USER_REPORTS: {
        text: "Reports",
        navigate: pageRoutes.USER_REPORTS,
    },
    PROFILE: {
        text: "Profile",
        navigate: pageRoutes.PROFILE,
    },
    PROFILE_SETTINGS: {
        text: "Profile Settings",
        navigate: pageRoutes.PROFILE_SETTINGS,
    },
    ACCOUNT_SETTINGS: {
        text: "Account Settings",
        navigate: pageRoutes.ACCOUNT_SETTINGS,
    },
    SUPPORT: {
        text: "Support",
        navigate: pageRoutes.SUPPORT,
    },
};
